<template>
	<div class="copyright">
		<van-nav-bar
			left-arrow
			fixed
		  	@click-left="$router.go(-1)">
		</van-nav-bar>
		<div class="logo">
			<van-image
				width="120"
				height="120"
				fit="contain"
				src="../../static/img/contact.png"
			/>
		</div>
		<p class="title">{{$t('ContactUs.contact')}}</p>
		<van-row class='title'>
			<van-col span="9">{{$t('ContactUs.area')}}</van-col>
			<van-col span="6">{{$t('ContactUs.name')}}</van-col>
			<van-col span="9">{{$t('ContactUs.phone')}}</van-col>
		</van-row>
		<van-row v-for="(item,index) in contacts" :key='index' class="content">
		  	<van-col span="9">{{item.area}}</van-col>
		  	<van-col span="6">{{item.name}}</van-col>
		  	<van-col span="9" @click='callPhone(item.phone)'>{{item.phone}}</van-col>
		</van-row>	
	</div>
</template>

<script>
export default {
    data () {
      	return {
      		contacts:[
                        {
                              area:this.$t('ContactUs.taiwan'),
                              name:this.$t('ContactUs.lin'),
                              phone:'+886 914143434',
                        },
                        {
                              area:this.$t('ContactUs.taiwan'),
                              name:this.$t('ContactUs.tian'),
                              phone:'+886 979966001',
                        },
                        {
                              area:this.$t('ContactUs.hongkong'),
                              name:this.$t('ContactUs.chan'),
                              phone:'+852 96438110',
                        },
      			// {
      			// 	area:this.$t('ContactUs.zhuhai'),
      			// 	name:this.$t('ContactUs.lin'),
      			// 	phone:'13714082522',
      			// },
      			// {
      			// 	area:this.$t('ContactUs.shanwei'),
      			// 	name:this.$t('ContactUs.chen'),
      			// 	phone:'15019424243',
      			// },
      			// {
      			// 	area:this.$t('ContactUs.shenzhen'),
      			// 	name:this.$t('ContactUs.qiu'),
      			// 	phone:'18370777559',
      			// },
      			// {
      			// 	area:this.$t('ContactUs.shantou'),
      			// 	name:this.$t('ContactUs.misschen'),
      			// 	phone:'18666682811',
      			// },
      			// {
      			// 	area:this.$t('ContactUs.dongguan'),
      			// 	name:this.$t('ContactUs.liu'),
      			// 	phone:'15817717507',
      			// },
      			// {
      			// 	area:this.$t('ContactUs.guilin'),
      			// 	name:this.$t('ContactUs.wang'),
      			// 	phone:'18575370602',
      			// },
      			// {
      			// 	area:this.$t('ContactUs.fuzhou'),
      			// 	name:this.$t('ContactUs.shi'),
      			// 	phone:'15060695780',
      			// },
      			
      		]
      	}
    },
    methods:{
    	// 调用拨号功能
		callPhone (phoneNumber) {
		    window.location.href = 'tel://' + phoneNumber
		}
    }
}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 26px;
		color: #fff;
	}
	.copyright{
		width: 100%;
		height: 100vh;
		background: #fff;
		text-align: center;
	}
	.title{
		color: #1e90ff;
		font-weight: bold;
	}
	.content{
		color: #707070
	}
	.van-col{
		padding-top:10px;
	}
      .logo{
            background: #000;
			padding-top: 46px;
      }
	
</style>



// WEBPACK FOOTER //
// src/reserve/ContactUs.vue